import { Injectable } from '@angular/core'
import { Translation, TranslocoLoader } from '@jsverse/transloco'
import { from } from 'rxjs'

/** Serves the translations from a hashed bundle chunk, so a key and its translation can never version apart. */
@Injectable({ providedIn: 'root' })
export class TranslocoBundledLoader implements TranslocoLoader {
  getTranslation() {
    return from(import('../i18n/cs.json').then((module) => module.default as Translation))
  }
}
